module.exports = __webpack_public_path__ + "static/media/capa-contato-1024.d7a7c765.jpg";